import React from 'react'

import useI18n from 'i18n/useI18n'
import { windowSizeBreakpoints } from 'utils/breakpoints'

import styled from 'theme/styled-components'
import useTheme from 'theme/useTheme'
import Button from 'components/button/Button'
import ChoiceList from 'components/picker/ChoiceList'

interface Props {
  closeModal: () => void
  bookings: SharvyParkingBooking[]
  onDelete: (bookings: SharvyParkingBooking[]) => void
}

const DeleteModal = ({ bookings, closeModal, onDelete }: Props) => {
  const [Theme] = useTheme()
  const i18n = useI18n()

  const [activeChoices, setActiveChoices] = React.useState<Choice[]>([])

  const choices: Choice[] = [
    {
      key: 'sharvyMorning',
      text: i18n.t('screens.planning.delete.sharvyMorning'),
    },
    {
      key: 'sharvyAfternoon',
      text: i18n.t('screens.planning.delete.sharvyAfternoon'),
    },
  ]

  const deleteBookings = () => {
    const isMorning = activeChoices.some((choice) => choice.key === 'sharvyMorning')
    const isAfternoon = activeChoices.some((choice) => choice.key === 'sharvyAfternoon')
    const filteredBookings = bookings.filter((b) => (b.isMorning ? isMorning : isAfternoon))

    onDelete(filteredBookings)
  }

  return (
    <DeleteBookingsContainer>
      <DeleteBookingsTitle>{i18n.t('screens.planning.delete.title')}</DeleteBookingsTitle>
      <DeleteBookingsSubtitle>{i18n.t('screens.planning.delete.description')}</DeleteBookingsSubtitle>
      <ChoiceList
        allChoices={choices}
        multipleChoices
        activeChoices={activeChoices}
        setActiveChoices={setActiveChoices}
      />
      <DeleteBookingsButtonsContainer>
        <Button
          font={Theme.fonts.h3Bold}
          onClick={deleteBookings}
          label={i18n.t('screens.planning.delete.deleteSelection')}
          color={Theme.colors.blue}
          textColor={Theme.colors.white}
          disabled={activeChoices.length === 0}
        />
        <Separator />
        <Button
          font={Theme.fonts.h3Bold}
          onClick={closeModal}
          label={i18n.t('common.cancel')}
          color={Theme.colors.white}
          textColor={Theme.colors.blue}
          shadow
        />
      </DeleteBookingsButtonsContainer>
    </DeleteBookingsContainer>
  )
}

export default DeleteModal

const DeleteBookingsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 40px;
  @media only screen and (max-width: ${windowSizeBreakpoints.phone}px) {
    padding: 15px;
  }
  min-width: 200px;
  max-width: 400px;
`

const DeleteBookingsTitle = styled.p`
  ${(props) => props.theme.fonts.h2Bold};
  margin: 0 0 20px;
`

const DeleteBookingsSubtitle = styled.p`
  ${(props) => props.theme.fonts.bodyBold};
`

const DeleteBookingsButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 20px;
`

const Separator = styled.div`
  height: 20px;
`
